import { render, staticRenderFns } from "./textOver.vue?vue&type=template&id=467282d6&scoped=true&"
import script from "./textOver.vue?vue&type=script&lang=js&"
export * from "./textOver.vue?vue&type=script&lang=js&"
import style0 from "./textOver.vue?vue&type=style&index=0&id=467282d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467282d6",
  null
  
)

export default component.exports